/*
Veneer
--species <string::enum> | [<Any Lumber Species>]
--core <string::enum> | ['Particle Board', 'MDF']
--coreThickness <float> | inches
--match <string::enum> | ['Sequence', 'Book', 'Slip']

--grade <boolean::switch> | ['Good 1 Side', 'Good 2 Side']

NOTE: These 2 attributes are are rare, can be considered custom, ignore on reports
--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Veneer'
const id = 'b1PZ5IAhIhIuHOqavZvq'

export default {
  name,
  id,
  filters,
  headers,
  form
}
